// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.manual-venue-entry[data-v-4e69b13d] {\n  padding: 15px 0;\n}\n.manual-venue-entry h4[data-v-4e69b13d] {\n  margin-bottom: 20px;\n}\n.buttons[data-v-4e69b13d] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
